import { render, staticRenderFns } from "./Additions.vue?vue&type=template&id=550d4031&scoped=true&"
import script from "./Additions.vue?vue&type=script&lang=js&"
export * from "./Additions.vue?vue&type=script&lang=js&"
import style0 from "./Additions.vue?vue&type=style&index=0&id=550d4031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550d4031",
  null
  
)

export default component.exports